import { render, staticRenderFns } from "./BranchesManagement.vue?vue&type=template&id=4f24b16e"
import script from "./BranchesManagement.vue?vue&type=script&lang=js"
export * from "./BranchesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports